import { Component, OnInit } from '@angular/core';
 import { OwlOptions } from 'ngx-owl-carousel-o/lib/models/owl-options.model';
import { MasterPageService } from 'src/app/core/services/master-page.service';

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss']
})
export class ArticlesComponent implements OnInit {
  articlesList;
  screenWidth;
  constructor(private masterPageService:MasterPageService) { }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;  
    this.masterPageService.getArticles().subscribe(item=>{
      this.articlesList=item;
      
    });
  }
  customOptions: OwlOptions = {
    items: 1,
    loop: true,
    dots: false,
    nav: true,
    autoplay: false,
    autoplayTimeout: 4000,
    autoWidth: true,
    stagePadding: 0,
    rtl: true,
    responsive:{
      768:{
        autoWidth: false,
        items: 3,
      },
    },
  }
}
